import React from 'react';
import { NavLink } from 'react-router-dom';

import FormattedMessage from 'components/formatted-message';

import { LAUNCHER_ICONS } from '../launcher-icons';
import { LAUNCHER_LABEL_IDS } from '../launcher-config';
import styles from '../app-launcher.module.css';

export const LauncherGrid = ({ items, onNavigate }) => (
    <div className={styles.grid}>
        {items.map(({ key, link }) => {
            const Icon = LAUNCHER_ICONS[key];
            const labelId = LAUNCHER_LABEL_IDS[key];

            return (
                <NavLink className={styles.gridItem} key={`${key}:${link.to}`} to={link.to} onClick={onNavigate}>
                    <span className={styles.iconWrap}>{Icon ? <Icon /> : null}</span>
                    {labelId ? <FormattedMessage id={labelId} /> : link.children}
                </NavLink>
            );
        })}
    </div>
);
